import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Chip,
  Box,
} from '@mui/material';
import { flowTemplates } from '../../../data/flowTemplates';

const TemplateCard = ({ template, onPick }) => {
  const screenCount = template.flowJson.screens?.length || 0;
  const componentCount = (template.flowJson.screens || []).reduce(
    (sum, s) => sum + (s.layout?.children?.length || 0),
    0,
  );

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card sx={{ height: '100%' }}>
        <CardActionArea
          onClick={() => onPick(template)}
          sx={{ height: '100%', alignItems: 'flex-start', display: 'flex' }}
          data-testid={`template-card-${template.id}`}
        >
          <CardContent sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
              <Typography variant="subtitle1" component="h3">
                {template.name}
              </Typography>
              <Chip label={template.category} size="small" />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {template.description}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {screenCount} screen{screenCount === 1 ? '' : 's'} · {componentCount} component{componentCount === 1 ? '' : 's'}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

const TemplateGalleryDialog = ({ open, onClose, onPick }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Start from a template</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Pick a template to open in the builder. You can edit anything before saving.
        </Typography>
        <Grid container spacing={2}>
          {/* Hidden templates are landing-page demo deep-link targets, not gallery picks. */}
          {flowTemplates.filter((t) => !t.hidden).map((template) => (
            <TemplateCard key={template.id} template={template} onPick={onPick} />
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateGalleryDialog;
